import React from "react";
//#region types
import { ReceiptPaymentStatusProps } from "models/propTypes/receiptPropTypes";
import { StyleEnums } from "models/enums";
import { WintSuperkollAPIModel as APIModels } from "wint-api-client/dist/types";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { Icon } from "components/common";
import { Grid, Tooltip } from "@mui/material";
import { useReceiptService } from "serviceHooks";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const ReceiptPaymentStatus: React.FC<ReceiptPaymentStatusProps> = (props) => {
  const receiptService = useReceiptService();
  const getPaymentStatusIcon = (status: APIModels.PaymentState) => {
    switch (status) {
      case APIModels.PaymentState.Paid:
        return {
          icon: IconDefinitionConstants.WValidateCheck,
          type: StyleEnums.DisplayType.Success,
        };
      default:
        return {
          icon: IconDefinitionConstants.WEmpty,
          type: StyleEnums.DisplayType.None,
        };
    }
  };

  const paymentValues = getPaymentStatusIcon(props.status);

  return paymentValues ? (
    <Tooltip
      disableInteractive
      placement="top"
      title={receiptService.getPaymentStatusText(props.status)}
      classes={{ tooltip: cssExports.tooltip, popper: cssExports.tooltipPopper }}
    >
      <Grid item>
        <Icon icon={paymentValues.icon} displayType={paymentValues.type} />
      </Grid>
    </Tooltip>
  ) : (
    <></>
  );
};

export default ReceiptPaymentStatus;
